import 'script-loader!cmeleon-core/shared/js/jquery';
import 'script-loader!cmeleon-core/core/js/bootstrap';
import 'script-loader!cmeleon-core/core/js/bootbox.min';
